<form class="form-horizontal" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="additionalLanguages.length > 0"
  ></app-translation-options>

  <!-- Name -->
  <div class="form-group">
    <label class="col-md-4 control-label">{{ 'NAME' | translate }}</label>
    <div class="col-md-8">
      <div class="form-label">{{ country.name }}</div>
    </div>
  </div>

  <!-- Code -->
  <div class="form-group">
    <label class="col-md-4 control-label">{{ 'CODE' | translate }}</label>
    <div class="col-md-8">
      <div class="form-label">{{ country.code }}</div>
    </div>
  </div>

  <!-- Phone code -->
  <div class="form-group">
    <label class="col-md-4 control-label">{{ 'PHONE_CODE' | translate }}</label>
    <div class="col-md-8">
      <div class="form-label">{{ country.phone_code }}</div>
    </div>
  </div>

  <div class="form-actions no-wrap">
    <button type="button" class="btn btn-lg" (click)="onCanceled()">
      {{ 'CLOSE' | translate }}
    </button>
  </div>

  <!-- <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="sendingForm"
      [isModal]="isModal"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
    >
    </app-item-detail-form-actions>
  </div> -->
</form>
